import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useSpring from 'hooks/useSpring'
import useOnMouseEnter from 'hooks/useOnMouseEnter'

const useArticleCardMouseAnimations = ({ cardRef }, onProgress) => {
  const [isHover, onMouseEnter, onMouseLeave] = useOnMouseEnter(cardRef)

  const [setSpring] = useSpring({
    progress: 0,
    config: {
      friction: 25,
      rigidity: 0.15,
    },
    onUpdate: ({ progress }, prevValue) => {
      if (progress !== prevValue.progress) {
        if (onProgress) onProgress(progress)
      }
    },
  })

  useIsomorphicLayoutEffect(() => {
    setSpring({
      progress: isHover ? 1 : 0,
    })
  }, [isHover])

  return [
    isHover,
    { onMouseEnter, onMouseLeave, onFocus: onMouseEnter, onBlur: onMouseLeave },
  ]
}

export default useArticleCardMouseAnimations
